import api from ".";

const API_URL = '/api/privateLabelQuotations';

export const getQuotations = async () => {
  try {
    const res = await api.get(API_URL);
    return res.data;
  } catch (error) {
    console.error("Get Quotations API Error:", error);
    throw error;
  }
};

export const createQuotation = async (quotationData) => {
  try {
    const res = await api.post(API_URL, quotationData);
    return res.data;
  } catch (error) {
    console.error("Create Quotation API Error:", error);
    throw error;
  }
};

export const updateQuotationStatus = async (id, status) => {
  try {
    const res = await api.put(`${API_URL}/${id}`, { status });
    return res.data;
  } catch (error) {
    console.error("Update Quotation Status API Error:", error);
    throw error;
  }
};

export const deleteQuotation = async (id) => {
  try {
    const res = await api.delete(`${API_URL}/${id}`);
    return res.data;
  } catch (error) {
    console.error("Delete Quotation API Error:", error);
    throw error;
  }
};
